export default __webpack_public_path__ + "static/media/loader.b69f16d8.gif";